import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { differenceInDays, startOfDay } from 'date-fns';

import { DATE_FORMAT_TYPES } from '@src/shared/src/const/app';
import { formatDateRange } from '@src/shared/src/util/date';
import { IRootState } from '@src/store';

import '../styles/HotelSelection.scss';

export const HotelSelection = () => {
  const { t } = useTranslation();
  const search = useSelector((state: IRootState) => state.search.currentSearch);

  return (
    <div className="hotel-selection">
      <div className="hotel-selection-title">{t('hotelFare.rooms')}</div>
      {`${formatDateRange(
        search.depAt,
        search.arrAt,
        '-',
        DATE_FORMAT_TYPES.SHORT_DATE,
      )} | ${differenceInDays(startOfDay(search.arrAt), startOfDay(search.depAt))} ${t(
        'global.nights',
      )} | ${search.passengers.length} ${
        search.passengers.length > 1 ? t('global.people') : t('global.person')
      }`}
    </div>
  );
};
